import styled from '@emotion/styled';
import React from 'react';
import { animated, useSpring } from 'react-spring';

interface IProps {
  isOpen: boolean;
  theme: string;
  size: 'small' | 'medium' | 'large';
}

function correctSize(size: string) {
  switch (size) {
    case 'small':
      return '29px';
    case 'medium':
      return '41px';
    case 'large':
      return '96px';
    default:
      return '96px';
  }
}

function borderSize(size: string) {
  switch (size) {
    case 'small':
      return '9px';
    case 'medium':
      return '14px';
    case 'large':
      return '30px';
    default:
      return '30px';
  }
}

const Div = styled.div<{ currentTheme: string; size: string }>`
  border-radius: 100px;
  background: ${({ theme, currentTheme }) => theme.colors[currentTheme]};
  height: ${({ size }) => correctSize(size)};
  width: ${({ size }) => correctSize(size)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotAnimatedSpan = styled(animated.span)<{ size: string }>`
  height: ${({ size }) => borderSize(size)};
  display: inline-block;
  width: 1px;
  border-left: 1px solid #ffffff;
  margin-left: ${({ size }) =>
    size === 'small' || size === 'medium' ? '-1px' : '0px'};
  transform-origin: center center;
  transform: rotate(90deg);
`;

const AnimatedSpan = styled(animated.span)<{ size: string }>`
  height: ${({ size }) => borderSize(size)};
  border-left: 1px solid #ffffff;
  width: 1px;
  display: inline-block;
  transform-origin: center center;
  transform: rotate(90deg);
`;

export const ExpandPlus = ({ isOpen, theme, size }: IProps) => {
  const rotate = useSpring({
    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
  });
  return (
    <Div currentTheme={theme} size={size}>
      <AnimatedSpan size={size} style={{ ...rotate }} />
      <NotAnimatedSpan size={size} />
    </Div>
  );
};
